import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

var firebaseConfig = {
  apiKey: "AIzaSyCIFr1XqOnfFBTZPD8f4j5Q52MSUf-zJ_g",
  authDomain: "property-website-8f2cb.firebaseapp.com",
  projectId: "property-website-8f2cb",
  storageBucket: "property-website-8f2cb.appspot.com",
  messagingSenderId: "710709708785",
  appId: "1:710709708785:web:97ee2d485494a0019ee650",
  measurementId: "G-JE9XM5W8GD",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
export const storage = firebase.storage();
export default firebase;
